export const getForgeApiMFCClient = async (): Promise<any> => {
    const { getForgeApiMFCClient } = await import(
        "adsForgeMfc/getForgeApiMFCClient"
    );
    return getForgeApiMFCClient();
};
